import React, { useMemo } from 'react';
import { SeedInfoDTO } from 'business/models/Models';
import { RockMakerSeedIcon } from '@fmlx/icons';
import { DropContentInfoCard } from './DropContentInfoCard';
import { compareByNameWithNullsLast } from 'utils/Global';
import {
  EPrecisionType,
  PrecisionFormatter,
} from 'components/plateviewer/render/plate/plateviewer/constants';

const SEED_WELL_SEPARATOR = ', ';

interface SeedInfoProps {
  seedInfos: SeedInfoDTO[];
  seedVolumeById?: Record<number, number>;
  formatWithPrecision: PrecisionFormatter;
}

export const SeedInfo = ({
  seedInfos,
  seedVolumeById = {},
  formatWithPrecision,
}: SeedInfoProps) => {
  const sortedSeeds = useMemo(() => {
    return seedInfos.sort((a, b) => compareByNameWithNullsLast(a.seedName, b.seedName));
  }, [seedInfos]);

  return (
    <div className="flex flex-col gap-2">
      {sortedSeeds.map((seed: SeedInfoDTO, idx) => {
        const header = seed.seedName ?? 'Seed';
        const seedWell = seed.sourceWellNames?.length
          ? seed.sourceWellNames.join(SEED_WELL_SEPARATOR)
          : `${seed.sourceWellRow}${seed.sourceWellColumn}`;
        const contents: string[] = [
          `Volume: ${formatWithPrecision(
            seedVolumeById[seed.seedId] ?? 0,
            EPrecisionType.Volume,
          )} μL`,
          `Source: Well ${seedWell}/Drop ${seed.sourceDropNumber} [${seed.sourcePlateId}], ${seed.sourceExperimentName}`,
        ];
        return (
          <DropContentInfoCard
            key={idx}
            header={header}
            contents={contents}
            icon={<RockMakerSeedIcon customSize={36} />}
          />
        );
      })}
    </div>
  );
};
